"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=e(require("styled-components")).default.ul`
    display: grid;
    grid-row-gap: 33px;

    @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 20px;
    }

    .detail {
        padding-left: 20px;
        position: relative;
        display: grid;
        grid-row-gap: 5px;

        h5 {
            margin: 0;
        }

        p {
            margin: 0;
        }

        &::after {
            display: block;
            content: '';
            width: 7px;
            height: 7px;
            border-radius: 100%;
            background: ${({theme:e})=>e.colors.grey[700]};
            position: absolute;
            top: 0.5em;
            left: 0;
        }
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
